import React, { useCallback, useEffect, useState, useRef, lazy } from 'react';
import { useTrackSection } from '../utils/useTrackSection';
const testimonials = [{
  name: 'Laura P.',
  location: 'Buenos Aires',
  role: 'Kinesióloga — Consultorio Privado',
  avatar: 'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=80&h=80&fit=crop&crop=face&auto=format&q=80',
  quote: 'Hola chicos! Las plantillas con framework SOAP del Tomo 1 me cambiaron la rutina. Pasé de tardar una hora documentando cada sesión a resolverlo en 10 minutos. Todo prolijo para la Obra Social. Muy agradecida 🙏',
  time: '14:32',
  reply: 'Hola Laura! Nos alegra muchísimo 😊 Cuando la documentación es ágil, todo el trabajo clínico mejora. ¡Seguí contándonos!'
}, {
  name: 'Martín C.',
  location: 'Rosario',
  role: 'Kinesiólogo Clínico — Centro de Rehabilitación',
  avatar: 'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=80&h=80&fit=crop&crop=face&auto=format&q=80',
  quote: 'Buenas! Apliqué los protocolos de traumatología del Tomo 3 con pacientes post-quirúrgicos. La progresión por fases está muy bien estructurada. Mis pacientes entienden cada etapa y eso genera mucha confianza. Muy buen material 👏',
  time: '09:15',
  reply: 'Martín, gracias por compartirlo! 🙌 Que el paciente entienda su proceso terapéutico es clave. ¡Excelente aplicación!'
}, {
  name: 'Sofía V.',
  location: 'Córdoba',
  role: 'Kinesióloga — Domiciliaria',
  avatar: 'https://images.unsplash.com/photo-1594824476967-48c8b964273f?w=80&h=80&fit=crop&crop=face&auto=format&q=80',
  quote: 'Hola a todos! El Tomo 4 tiene exactamente lo que necesitaba para pacientes neurológicos domiciliarios. El apartado de seguridad del kinesiólogo me pareció clave, nadie lo enseña. El contenido supera lo esperado. Gracias totales 🙌',
  time: '18:47',
  reply: 'Sofía, qué bueno leerte! 😄 El contexto domiciliario tiene particularidades que muy pocos materiales abordan en serio. ¡Seguí así!'
}, {
  name: 'Diego R.',
  location: 'Mendoza',
  role: 'Kinesiólogo — Traumatología Deportiva',
  avatar: 'https://images.unsplash.com/photo-1537368910025-700350fe46c7?w=80&h=80&fit=crop&crop=face&auto=format&q=80',
  quote: 'Qué tal! El Tomo 5 de neurociencia aplicada al dolor es de otro nivel. Empecé con educación terapéutica y la adherencia de mis pacientes mejoró muchísimo. Abandonan menos y confían más en el proceso. Excelente trabajo 💪',
  time: '11:03',
  reply: 'Diego, gracias! 💪 Cuando el paciente comprende el dolor desde la neurociencia, el proceso terapéutico acelera. ¡Justo el objetivo!'
}, {
  name: 'Valentina M.',
  location: 'Santa Fe',
  role: 'Kinesióloga — Obras Sociales',
  avatar: 'https://images.unsplash.com/photo-1651008376811-b90baee60c1f?w=80&h=80&fit=crop&crop=face&auto=format&q=80',
  quote: 'Hola! Tenía una auditoría de Obra Social y con las plantillas del Tomo 1 presenté todo sin observaciones. El lenguaje técnico-administrativo es exactamente lo que piden. Primera vez que paso una auditoría sin estrés. Muy agradecida 🙏',
  time: '20:21',
  reply: 'Valentina, qué alivio leerlo! 😊 Tener la documentación en orden marca toda la diferencia. ¡Muy bien por vos!'
}, {
  name: 'Federico A.',
  location: 'La Plata',
  role: 'Kinesiólogo — Recién Graduado',
  avatar: 'https://images.unsplash.com/photo-1622253692010-333f2da6031d?w=80&h=80&fit=crop&crop=face&auto=format&q=80',
  quote: 'Buenas! El Bono de Hoja de Ruta me guió paso a paso para armar mi primer consultorio. Habilitación, equipamiento, honorarios, primeros 90 días. Todo lo que la facultad no enseña. Ahora tengo agenda llena y sistema. No tiene precio 🙌',
  time: '16:58',
  reply: 'Fede, esto nos llena de orgullo! 🥹 Arrancar con estructura desde el día uno te ahorra años de prueba y error. ¡Mucho éxito!'
}, {
  name: 'Carolina B.',
  location: 'Tucumán',
  role: 'Kinesióloga — Neurología y Geriatría',
  avatar: 'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=80&h=80&fit=crop&crop=face&auto=format&q=80',
  quote: 'Hola chicos! El Tomo 4 tiene criterios muy sólidos para evaluar funcionalidad en pacientes neurológicos y geriátricos. El Bono de Scripts además me ayudó con la comunicación familiar. Lo recomiendo al 100% ✨',
  time: '13:44',
  reply: 'Carolina, gracias! ✨ La comunicación con familias en neurología es tan importante como el trabajo clínico. ¡Nos alegra que haya aportado ahí también!'
}];
function WhatsAppChat({
  t
}: {
  t: (typeof testimonials)[0];
}) {
  return <div className="rounded-xl overflow-hidden shadow-lg w-full" style={{
    backgroundColor: '#111b21'
  }} data-id="element-297">
      {/* Header */}
      <div className="flex items-center gap-3 px-4 py-3" style={{
      backgroundColor: '#1f2c34'
    }} data-id="element-298">
        <div className="relative" data-id="element-299">
          <img src={t.avatar} alt={t.name} width={40} height={40} loading="lazy" decoding="async" className="w-10 h-10 rounded-full object-cover" data-id="element-300" />
          <div className="absolute bottom-0 right-0 w-3 h-3 rounded-full border-2" style={{
          backgroundColor: '#22c55e',
          borderColor: '#1f2c34'
        }} data-id="element-301" />
        </div>
        <div className="flex-1 min-w-0" data-id="element-302">
          <p className="font-semibold text-white m-0 text-sm truncate" data-id="element-303">
            {t.name}
          </p>
          <p className="m-0 text-xs" style={{
          color: '#8696a0'
        }} data-id="element-304">
            {t.role} · {t.location}
          </p>
        </div>
        <div style={{
        color: '#aebac1'
      }} data-id="element-305">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-306">
            <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" data-id="element-307" />
          </svg>
        </div>
      </div>

      {/* Chat area */}
      <div className="px-3 py-4 flex flex-col justify-end gap-2" style={{
      backgroundColor: '#0b141a',
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg width='200' height='200' xmlns='http://www.w3.org/2000/svg'%3E%3Cdefs%3E%3Cpattern id='p' width='40' height='40' patternUnits='userSpaceOnUse'%3E%3Ccircle cx='20' cy='20' r='1' fill='%23ffffff08'/%3E%3C/pattern%3E%3C/defs%3E%3Crect width='200' height='200' fill='url(%23p)'/%3E%3C/svg%3E\")"
    }} data-id="element-308">
        {/* Incoming bubble */}
        <div className="max-w-[88%] self-start relative" data-id="element-309">
          <div className="absolute -left-2 top-0 w-0 h-0" style={{
          borderTop: '8px solid #1f2c34',
          borderLeft: '8px solid transparent'
        }} data-id="element-310" />
          <div className="rounded-lg rounded-tl-none px-3 py-2" style={{
          backgroundColor: '#1f2c34'
        }} data-id="element-311">
            <p className="m-0 text-sm leading-relaxed" style={{
            color: '#e9edef'
          }} data-id="element-312">
              {t.quote}
            </p>
            <div className="flex items-center justify-end gap-1 mt-1" data-id="element-313">
              <span className="text-xs" style={{
              color: '#8696a0'
            }} data-id="element-314">
                {t.time}
              </span>
              <svg width="16" height="11" viewBox="0 0 16 11" fill="none" data-id="element-315">
                <path d="M11.071.653a.457.457 0 0 0-.304-.102.493.493 0 0 0-.381.178l-6.19 7.636-2.011-2.175a.463.463 0 0 0-.336-.153.457.457 0 0 0-.344.153.52.52 0 0 0 0 .688l2.357 2.547a.478.478 0 0 0 .336.178h.025a.46.46 0 0 0 .356-.178l6.537-8.063a.477.477 0 0 0-.046-.71z" fill="#53bdeb" data-id="element-316" />
                <path d="M15.071.653a.457.457 0 0 0-.304-.102.493.493 0 0 0-.381.178l-6.19 7.636-1.2-1.298-.712.737 1.557 1.683a.478.478 0 0 0 .336.178h.025a.46.46 0 0 0 .356-.178l6.537-8.063a.477.477 0 0 0-.046-.71z" fill="#53bdeb" data-id="element-317" />
              </svg>
            </div>
          </div>
        </div>

        {/* Reply bubble */}
        <div className="max-w-[75%] self-end relative mt-1" data-id="element-318">
          <div className="absolute -right-2 top-0 w-0 h-0" style={{
          borderTop: '8px solid #005f8e',
          borderRight: '8px solid transparent'
        }} data-id="element-319" />
          <div className="rounded-lg rounded-tr-none px-3 py-2" style={{
          backgroundColor: '#005f8e'
        }} data-id="element-320">
            <p className="m-0 text-sm leading-relaxed" style={{
            color: '#e9edef'
          }} data-id="element-321">
              {t.reply}
            </p>
            <div className="flex items-center justify-end gap-1 mt-1" data-id="element-322">
              <span className="text-xs" style={{
              color: '#bae6fd'
            }} data-id="element-323">
                {t.time}
              </span>
              <svg width="16" height="11" viewBox="0 0 16 11" fill="none" data-id="element-324">
                <path d="M11.071.653a.457.457 0 0 0-.304-.102.493.493 0 0 0-.381.178l-6.19 7.636-2.011-2.175a.463.463 0 0 0-.336-.153.457.457 0 0 0-.344.153.52.52 0 0 0 0 .688l2.357 2.547a.478.478 0 0 0 .336.178h.025a.46.46 0 0 0 .356-.178l6.537-8.063a.477.477 0 0 0-.046-.71z" fill="#bae6fd" data-id="element-325" />
                <path d="M15.071.653a.457.457 0 0 0-.304-.102.493.493 0 0 0-.381.178l-6.19 7.636-1.2-1.298-.712.737 1.557 1.683a.478.478 0 0 0 .336.178h.025a.46.46 0 0 0 .356-.178l6.537-8.063a.477.477 0 0 0-.046-.71z" fill="#bae6fd" data-id="element-326" />
              </svg>
            </div>
          </div>
        </div>
      </div>

      {/* Input bar */}
      <div className="flex items-center gap-2 px-3 py-2" style={{
      backgroundColor: '#1f2c34'
    }} data-id="element-327">
        <div style={{
        color: '#8696a0'
      }} data-id="element-328">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" data-id="element-329">
            <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm0 18c-4.418 0-8-3.582-8-8s3.582-8 8-8 8 3.582 8 8-3.582 8-8 8zm-4-9a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0zm5 0a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0zm-5.5 3.5c.828 1.5 2.5 2.5 4.5 2.5s3.672-1 4.5-2.5" data-id="element-330" />
          </svg>
        </div>
        <div className="flex-1 rounded-full px-4 py-2 text-sm" style={{
        backgroundColor: '#2a3942',
        color: '#8696a0'
      }} data-id="element-331">
          Escribe un mensaje
        </div>
        <div style={{
        color: '#8696a0'
      }} data-id="element-332">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" data-id="element-333">
            <path d="M12 15c1.66 0 3-1.34 3-3V6c0-1.66-1.34-3-3-3S9 4.34 9 6v6c0 1.66 1.34 3 3 3zm5-3c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-2.08c3.39-.49 6-3.39 6-6.92h-2z" data-id="element-334" />
          </svg>
        </div>
      </div>
    </div>;
}
export function Testimonials() {
  useTrackSection('testimonials', 'Testimonials Section');
  const [current, setCurrent] = useState(0);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const trackRef = useRef<HTMLDivElement>(null);
  const total = testimonials.length;
  const goTo = useCallback((index: number) => {
    setCurrent(index);
  }, []);
  const next = useCallback(() => {
    goTo((current + 1) % total);
  }, [current, total, goTo]);
  const prev = useCallback(() => {
    goTo((current - 1 + total) % total);
  }, [current, total, goTo]);
  useEffect(() => {
    intervalRef.current = setInterval(() => next(), 8000);
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [next]);
  const touchStartX = useRef(0);
  const handleTouchStart = (e: React.TouchEvent) => {
    touchStartX.current = e.touches[0].clientX;
  };
  const handleTouchEnd = (e: React.TouchEvent) => {
    const diff = touchStartX.current - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) {
      if (diff > 0) next();else prev();
    }
  };
  return <section id="testimonials" className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(235,248,255) 0%, rgb(224,247,255) 15%, rgb(224,247,255) 85%, rgb(235,248,255) 100%)',
    fontFamily: 'var(--font-system)'
  }} data-id="element-335">
      <div className="mx-auto max-w-2xl" data-id="element-336">
        {/* Heading */}
        <h2 className="text-3xl font-black text-center text-gray-900 m-0 mb-2" data-id="element-337">
          Lo que dicen los kinesiólogos{' '}
          <span style={{
          color: '#0077B6'
        }} data-id="element-338">
            que ya lo implementaron:
          </span>
        </h2>
        <p className="text-center text-sm text-gray-500 m-0 mb-8" data-id="element-339">
          +400 kinesiólogos de todo el país ya tienen un sistema que funciona.
        </p>

        {/* Carousel wrapper */}
        <div className="relative" onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd} data-id="element-340">
          {/* Arrow prev */}
          <button onClick={prev} className="absolute left-0 top-1/2 -translate-y-1/2 sm:-translate-x-12 z-10 w-9 h-9 rounded-full flex items-center justify-center transition-all hover:scale-110 hover:brightness-110" style={{
          backgroundColor: '#0077B6',
          color: '#fff'
        }} aria-label="Anterior testimonio" data-id="element-341">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-342">
              <path d="m15 18-6-6 6-6" data-id="element-343" />
            </svg>
          </button>

          {/* Arrow next */}
          <button onClick={next} className="absolute right-0 top-1/2 -translate-y-1/2 sm:translate-x-12 z-10 w-9 h-9 rounded-full flex items-center justify-center transition-all hover:scale-110 hover:brightness-110" style={{
          backgroundColor: '#0077B6',
          color: '#fff'
        }} aria-label="Siguiente testimonio" data-id="element-344">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-345">
              <path d="m9 18 6-6-6-6" data-id="element-346" />
            </svg>
          </button>

          {/* Sliding track */}
          <div className="overflow-hidden rounded-xl mx-10 sm:mx-0" data-id="element-347">
            <div ref={trackRef} className="flex" style={{
            transform: `translateX(-${current * 100}%)`,
            transition: 'transform 0.45s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
            willChange: 'transform'
          }} data-id="element-348">
              {testimonials.map((t, i) => <div key={i} className="w-full shrink-0" data-id="element-349">
                  <WhatsAppChat t={t} data-id="element-350" />
                </div>)}
            </div>
          </div>

          {/* Progress bar */}
          <div className="mt-5 mx-auto max-w-xs h-1 rounded-full overflow-hidden" style={{
          backgroundColor: 'rgba(0,119,182,0.15)'
        }} data-id="element-351">
            <div key={`progress-${current}`} className="h-full rounded-full" style={{
            backgroundColor: '#0077B6',
            width: '100%',
            transformOrigin: 'left',
            animation: 'progressFill 8s linear forwards'
          }} data-id="element-352" />
          </div>

          {/* Dots */}
          <div className="flex items-center justify-center gap-2 mt-4" data-id="element-353">
            {testimonials.map((_, i) => <button key={i} onClick={() => goTo(i)} className="transition-all duration-300 rounded-full" style={{
            width: i === current ? 24 : 8,
            height: 8,
            backgroundColor: i === current ? '#0077B6' : 'rgba(0,119,182,0.20)'
          }} aria-label={`Ir al testimonio ${i + 1}`} data-id="element-354" />)}
          </div>

          {/* Counter */}
          <p className="text-center mt-3 m-0 text-xs" style={{
          color: '#0077B6'
        }} data-id="element-355">
            {current + 1} / {total}
          </p>
        </div>
      </div>
    </section>;
}